export const personalDataControl = {
    title: 'Контроль личных сведений',
    isBordered: true,
    blocks: [
        {
            type: 'text',
            value: 'Компания обязуется не использовать Ваши личные данные в иных целях. Эти сведения не будут передаваться третьим лицам без Вашего дополнительного разрешения, за исключением случаев, регулируемых законодательством РФ.',
        },
    ],
};
